import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, string>({
        query: (id) => ({
            url: `${APP_ENDPOINTS.WEBSITE}/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: [
            { type: 'websites', id: 'GET' },
            { type: 'websites-with-join', id: 'GET-JOIN' },
        ],
    });
